


































































import Vue from 'vue';

import Util from '@/util/Util.ts';

export default Vue.extend({
    name: 'FrequentlyAskedQuestions',

    created() {
		Util.updateHeaders('FAQ', 'Här hittar ni svar på de vanligaste frågorna.', process.env.VUE_APP_DEFAULT_IMAGE);
    }
});
